/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesGameRoleSchema } from "./gameRoleSchema.ts";
import { goodLuckCoreEntitiesTournamentTeamSchema } from "./tournamentTeamSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentTeamMemberSchema = z.object({
  id: z.string().nullish(),
  tournamentTeamId: z.string().nullish(),
  userId: z.string().nullish(),
  get role() {
    return goodLuckCoreEntitiesGameRoleSchema.optional();
  },
  joinedAt: z.optional(z.iso.datetime()),
  get tournamentTeam() {
    return goodLuckCoreEntitiesTournamentTeamSchema.optional();
  },
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
});
